// src/pages/LoginForm.jsx

import React, { useEffect, useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { postLogin } from "../helpers/rutaUsuarios";
import "../css/loginform.css";

const LoginForm = () => {
  const history = useHistory();

  // Campos del formulario
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });

  // Estado de la respuesta de login
  const [user, setUser] = useState({
    data: { ok: null },
    loading: false,
  });

  // Flag local para saber si estamos logueados
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("token")
  );

  // Efecto: al recibir respuesta exitosa de login
  useEffect(() => {
    if (user.data.ok) {
      // Guardar token y datos
      localStorage.setItem("token", user.data.token);
      localStorage.setItem("id", user.data.usuario._id);
      localStorage.setItem(
        "usuario",
        JSON.stringify(user.data.usuario.nombres)
      );

      // Marcar como logueado
      setIsLoggedIn(true);

      // Redirigir al home para mostrar menú
      history.push("/");
    }
  }, [user, history]);

  // Timer de inactividad
  const logout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    history.push("/login");
  };

  const resetTimer = () => {
    clearTimeout(window.inactivityTimeout);
    window.inactivityTimeout = setTimeout(logout, 60 * 100000);
  };

  useEffect(() => {
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      clearTimeout(window.inactivityTimeout);
    };
  }, []);

  // Handlers de formulario
  const handleChange = (e) =>
    setFormValues({ ...formValues, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setUser((u) => ({ ...u, loading: true }));
    postLogin(formValues).then((datos) => setUser(datos));
    setFormValues({ email: "", password: "" });
  };

  // Si ya estamos logueados, redirigimos (por si accede manualmente a /login)
  if (isLoggedIn) {
    return <Redirect to="/" />;
  }

  // Render del formulario
  return (
    <main className="login-container">
      <div className="login-box">
        <h2 className="text-center mb-4">APP COMERCIAL AGRICOLA</h2>
        <h2 className="text-center mb-4">SAN PANCRACIO SRL</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Correo electrónico</label>
            <input
              id="email"
              type="email"
              className="form-control"
              name="email"
              value={formValues.email}
              onChange={handleChange}
              required
              autoFocus
            />
          </div>
          <div className="form-group mt-3">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              className="form-control"
              name="password"
              value={formValues.password}
              onChange={handleChange}
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn-dark btn-block mt-4"
            disabled={user.loading}
          >
            {user.loading ? "Validando..." : "Iniciar sesión"}
          </button>
        </form>

        {user.data.ok === false && (
          <div className="alert alert-danger mt-3 text-center">
            {user.data.err?.message || "Error al iniciar sesión"}
          </div>
        )}
      </div>
    </main>
  );
};

export default LoginForm;
